<template>
  <ion-app :class="{ 'has-supervision-banner': hasSupervisionBanner }">
    <SupervisionBanner />
    <AvisoAppModal />
    <AppVersionOutdatedModal />
    <ion-loading :is-open="mainStoreInstance.$state.loading.show" :message="mainStoreInstance.$state.loading.message" :backdrop-dismiss="true"> </ion-loading>
    <ion-alert
      :is-open="mainStoreInstance.$state.loading.timedOut"
      header="No se pudo cargar"
      message="La espera ha tardado demasiado. Puedes reintentar o seguir usando la app."
      :buttons="loadingTimeoutButtons"
      @didDismiss="mainStoreInstance.clearLoadingTimeout()"
    ></ion-alert>
  
    <ion-menu v-if="sesionIniciada" content-id="main-content">
      <ion-header>
        <ion-toolbar>
          <ion-title>Menu</ion-title>
        </ion-toolbar>
      </ion-header>
      <ion-content class="ion-padding menu-content">
        <ion-list>
          <ion-item button @click="openHome">
            <ion-icon slot="start" :icon="homeOutline"></ion-icon>
            Inicio
          </ion-item>

          <ion-item 
                    button 
                    @click="openSesiones" 
                    v-if="userAuth().hasRole('coordinador de actividad') || userAuth().hasRole('profesor')"
                    >
            <ion-icon slot="start" :icon="schoolOutline"></ion-icon>
            Clases
          </ion-item>

          <ion-item button @click="openEventos">
            <ion-icon slot="start" :icon="calendarOutline"></ion-icon>
            Eventos
          </ion-item>

          <ion-item
                    button
                    @click="openVideosDescarga"
                    v-if="userAuth().puedeDescargarVideos()"
                    >
            <ion-icon slot="start" :icon="videocamOutline"></ion-icon>
            Descargar vídeos
          </ion-item>

          <ion-item 
                    button 
                    @click="openQRScanner"
                    v-if="userAuth().hasRole('coordinador de actividad')"
                    >
            <ion-icon slot="start" :icon="qrCodeOutline"></ion-icon>
            Lector QR
          </ion-item>

          <ion-item v-if="sesionIniciada" button @click="openMensajes">
            <ion-icon slot="start" :icon="chatbubblesOutline"></ion-icon>
            Mensajes
          </ion-item>

          <ion-item v-if="sesionIniciada" button @click="openAlquileres">
            <ion-icon slot="start" :icon="businessOutline"></ion-icon>
            Alquileres
          </ion-item>

          <ion-item v-if="sesionIniciada" button @click="openSaldo">
            <ion-icon slot="start" :icon="walletOutline"></ion-icon>
            Mi Saldo
          </ion-item>

          <ion-item
                    button
                    @click="openContarAsistentes"
                    v-if="userAuth().hasRole('coordinador de actividad')"
                    >
            <ion-icon slot="start" :icon="eyeOutline"></ion-icon>
            Contar personas
          </ion-item>

          <ion-item v-if="sesionIniciada" button @click="openIncidencias">
            <ion-icon slot="start" :icon="warningOutline"></ion-icon>
            Incidencias
          </ion-item>

          <ion-item 
                      button 
                      @click="openWhatsappLauncher"
                      v-if="userAuth().can('Buscar alumnos para Whatsapp Launcher')"
                      >
            Lanzador de Whatsapps
          </ion-item>

          <ion-item 
                      button 
                      @click="openDeteccionNecesidades"
                      v-if="userAuth().can('Añadir deteccion de necesidades')"
                      >
            Detección de necesidades
          </ion-item>

          <ion-item 
                    button 
                    @click="openEntregas"
                    v-if="userAuth().hasRole('coordinador de actividad')"
                    >
            <ion-icon slot="start" :icon="cubeOutline"></ion-icon>
            Entregas
          </ion-item>

          <ion-item v-if="sesionIniciada" button @click="openDomotica">
            <ion-icon slot="start" :icon="flashOutline"></ion-icon>
            Domótica
          </ion-item>

          <ion-item v-if="sesionIniciada" button @click="openLiquidacion">
            <ion-icon slot="start" :icon="documentTextOutline"></ion-icon>
            Liquidación
          </ion-item>

          <ion-item button @click="openPoliticaPrivacidad">
            <ion-icon slot="start" :icon="documentTextOutline"></ion-icon>
            Política de privacidad
          </ion-item>
        </ion-list>
        <div class="menu-footer">
          <ion-note class="menu-footer__version">
            Versión {{ require('../package.json').version }}
          </ion-note>
          <div v-if="sesionIniciada" class="menu-footer__user">
            <ion-note>Hola, {{ tools().getShortName( currentUserStore().user?.name || '') }}</ion-note>
            <a href="#" class="menu-footer__logout" @click.prevent="logout">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg>
            </a>
          </div>
        </div>
      </ion-content>
    </ion-menu>
    
    <ion-router-outlet id="main-content" />

    <ion-button
      v-if="sesionIniciada"
      class="home-shortcut-btn"
      fill="solid"
      shape="round"
      color="light"
      @click="openHome"
    >
      <ion-icon :icon="homeOutline"></ion-icon>
    </ion-button>

    <div v-if="mostrarGloboWhatsapp" class="wa-fab-wrap">
      <button
        type="button"
        class="wa-fab"
        :aria-label="waUnreadLabel"
        @click="openWhatsappInbox"
      >
        <ion-icon :icon="logoWhatsapp"></ion-icon>
      </button>
      <span v-if="waUnread > 0" class="wa-fab__badge">{{ waUnread > 99 ? '99+' : waUnread }}</span>
    </div>
    
    <!-- Floating Message Indicator -->
    <FloatingMessageIndicator v-if="sesionIniciada && route.name !== 'WhatsApp'" />
  </ion-app>
</template>

<script lang="ts" setup>
import { mainStore } from '@/stores/mainStore';
import { IonApp, IonLoading, IonAlert, IonMenu, IonHeader, IonToolbar, IonTitle, IonContent, IonNote, IonRouterOutlet, IonItem, IonList, IonButton, IonIcon, menuController, useBackButton } from '@ionic/vue';
import tools from '@/composables/tools';
import { alquilerUiLog } from '@/composables/alquilerUiLog';
import router from '@/router';
import { currentUserStore } from '@/stores/currentUser'
import userAuth from './composables/userAuth';
import FloatingMessageIndicator from '@/components/FloatingMessageIndicator.vue';
import SupervisionBanner from '@/components/SupervisionBanner.vue';
import AvisoAppModal from '@/components/AvisoAppModal.vue';
import AppVersionOutdatedModal from '@/components/AppVersionOutdatedModal.vue';
import { useAvisoApp } from '@/composables/useAvisoApp';
import { configureNativeStatusBar } from '@/composables/useNativeStatusBar';
import { computed, onMounted, onUnmounted, ref, watch } from 'vue';
import { useWhatsappUnread } from '@/composables/useWhatsappUnread';
import { useRoute } from 'vue-router';
import { trackMenuAccess } from '@/composables/menuUsage';
import { markAccesoVideosDescarga } from '@/composables/videosDescargaUi';
import {
  homeOutline,
  schoolOutline,
  calendarOutline,
  qrCodeOutline,
  chatbubblesOutline,
  businessOutline,
  walletOutline,
  warningOutline,
  cubeOutline,
  flashOutline,
  documentTextOutline,
  eyeOutline,
  videocamOutline,
  logoWhatsapp,
} from 'ionicons/icons';

const route = useRoute();
const sesionIniciada = computed(() => mainStore().isLogged || userAuth().hasToken());
const puedeVerWhatsapp = computed(() =>
  sesionIniciada.value
  && userAuth().hasAnyRole(['administrador', 'coordinador de actividad'])
);
const mostrarGloboWhatsapp = computed(() => puedeVerWhatsapp.value && route.name !== 'WhatsApp');
const { unreadCount: waUnread, fetchUnreadCount, start: startWaUnread, stop: stopWaUnread } = useWhatsappUnread();
const waUnreadLabel = computed(() =>
  waUnread.value > 0
    ? `Conversaciones de WhatsApp, ${waUnread.value} sin leer`
    : 'Conversaciones de WhatsApp'
);

watch(puedeVerWhatsapp, (visible) => {
  if (visible) startWaUnread();
  else stopWaUnread();
}, { immediate: true });

watch(() => route.name, (name, previous) => {
  if (previous === 'WhatsApp' && name !== 'WhatsApp' && puedeVerWhatsapp.value) {
    void fetchUnreadCount();
  }
});

onUnmounted(() => {
  stopWaUnread();
});

const loadingTimeoutButtons = [
  {
    text: 'Cerrar',
    role: 'cancel',
    handler: () => mainStore().clearLoadingTimeout(),
  },
  {
    text: 'Reintentar',
    handler: () => {
      mainStore().clearLoadingTimeout();
      location.reload();
    },
  },
];

const mainStoreInstance = mainStore();
const avisoApp = useAvisoApp();
const hasSupervisionBanner = ref(!!localStorage.getItem('supervision'));

useBackButton(10, () => {
  // Consume el atrás físico / WebView: no sale de la pantalla.
});

onMounted(() => {
  void configureNativeStatusBar();
  if (localStorage.getItem('token')) {
    avisoApp.startPolling();
  }
});

const closeMenu = async() => {
      await menuController.toggle();
}

const openSesiones = () => {
  tools().setLog('Abre lista de sesiones desde el menú');
  trackMenuAccess('clases');
  router.push({ name: 'Sesiones'})
  closeMenu();
};

const openHome = () => {
  tools().setLog('Abre inicio desde el menú');
  router.push('/inicio');
  closeMenu();
};

const openVideosDescarga = () => {
  tools().setLog('Abre descarga de vídeos');
  markAccesoVideosDescarga('menu')
  router.push({ name: 'Descargar vídeos' });
  closeMenu();
};

const openPoliticaPrivacidad = () => {
  window.open('https://galidancia.com/politica-de-privacidad/', '_blank', 'noopener,noreferrer');
  closeMenu();
};

const logout = async () => {
  await closeMenu();
  await userAuth().logout();
};

const openAlquileres = () => {
  alquilerUiLog('menu_abre_alquileres')
  trackMenuAccess('alquileres');
  location.href = '/alquileres'; //me da error si no lo hago asi.. .tengo q solucionarlo
};

const openSaldo = () => {
  tools().setLog('Abre la sección de saldo desde el menú');
  trackMenuAccess('mi_saldo');
  location.href = '/saldo';
  closeMenu();
};

const openEventos = () => {
  tools().setLog('Abre lista de eventos desde el menú');
  trackMenuAccess('eventos');
  location.href = '/eventos'; //me da error si no lo hago asi.. .tengo q solucionarlo
  //router.push({ name: 'Eventos' });
  closeMenu();
};

const openMensajes = () => {
  tools().setLog('Abre lista de mensajes desde el menú');
  trackMenuAccess('mensajes');
  location.href = '/mensajes'; //me da error si no lo hago asi.. .tengo q solucionarlo
  //router.push({ name: 'Eventos' });
  closeMenu();
};

const openIncidencias = () => {
  tools().setLog('Abre lista de incidencias desde el menú');
  trackMenuAccess('incidencias');
  location.href = '/Organizacion/incidencias'; //me da error si no lo hago asi.. .tengo q solucionarlo
  //router.push({ name: 'Eventos' });
  closeMenu();
};

const openContarAsistentes = () => {
  tools().setLog('Abre contaje aleatorio de personas en sesión');
  trackMenuAccess('contar_personas');
  location.href = '/contar-asistentes';
  closeMenu();
};

const openQRScanner = () => {
  tools().setLog('Abre el escanner QR desde el menú');
  trackMenuAccess('lector_qr');
  location.href = 'https://escaner.gest.galidancia.com'; //me da error si no lo hago asi.. .tengo q solucionarlo
  //router.push({ name: 'Eventos' });
  closeMenu();
};

const openDeteccionNecesidades = () => {
  tools().setLog('Abre formulario de detección de necesidades');
  location.href = '/necesidades'; //me da error si no lo hago asi.. .tengo q solucionarlo
  //router.push({ name: 'Eventos' });
  closeMenu();
};

const openWhatsappInbox = () => {
  tools().setLog('Abre el buzón de WhatsApp');
  router.push({ name: 'WhatsApp' });
};

const openWhatsappLauncher = () => {
  tools().setLog('Abre el whatsapp launcher');
  location.href = '/whatsappLauncher'; //me da error si no lo hago asi.. .tengo q solucionarlo
  //router.push({ name: 'Whatsapp Launcher' });
  closeMenu();
};

const openEntregas = () => {
  tools().setLog('Abre lista de entregas desde el menú');
  trackMenuAccess('entrega');
  router.push('/entrega');
  closeMenu();
};

const openDomotica = () => {
  tools().setLog('Abre la sección de domótica desde el menú');
  trackMenuAccess('domotica');
  location.href = '/domotica';
  closeMenu();
};

const openLiquidacion = () => {
  tools().setLog('Abre la sección de liquidación desde el menú');
  trackMenuAccess('liquidacion');
  location.href = '/liquidacion';
  closeMenu();
};
</script>

<style scoped>
.menu-footer {
  text-align: center;
  padding: 8px 0 calc(12px + env(safe-area-inset-bottom, 0px));
}

.menu-footer__version {
  font-size: smaller;
}

.menu-footer__user {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 4px;
}

.menu-footer__logout {
  margin-left: 12px;
  color: var(--ion-color-danger);
  text-decoration: none;
  display: inline-flex;
  align-items: center;
}

.home-shortcut-btn {
  position: fixed;
  top: calc(env(safe-area-inset-top) + 8px);
  right: 12px;
  z-index: 1200;
  --padding-start: 10px;
  --padding-end: 10px;
  --box-shadow: 0 8px 18px rgba(15, 23, 42, 0.2);
}

.home-shortcut-btn ion-icon {
  font-size: 1.2rem;
}

.wa-fab-wrap {
  position: fixed;
  right: 16px;
  bottom: 60px;
  z-index: 1100;
  width: 56px;
  height: 56px;
}

.wa-fab {
  width: 56px;
  height: 56px;
  margin: 0;
  padding: 0;
  border: 0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #25d366;
  color: #fff;
  box-shadow: 0 6px 16px rgba(18, 140, 94, 0.45);
  cursor: pointer;
}

.wa-fab__badge {
  position: absolute;
  top: -6px;
  right: -6px;
  min-width: 20px;
  height: 20px;
  padding: 0 5px;
  border: 2px solid #fff;
  border-radius: 12px;
  background: #ff4444;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  line-height: 16px;
  text-align: center;
  box-sizing: border-box;
}

.wa-fab ion-icon {
  font-size: 30px;
}
</style>

<style>
ion-app.has-supervision-banner {
  --galidancia-gest-supervision-banner-offset: calc(env(safe-area-inset-top, 0px) + 88px);
}

ion-app.has-supervision-banner ion-page ion-header {
  margin-top: var(--galidancia-gest-supervision-banner-offset);
}

ion-app.has-supervision-banner .home-shortcut-btn {
  top: calc(var(--galidancia-gest-supervision-banner-offset) + 8px);
}
</style>
